import { DataSecurityLevel, ERROR, FROM_CACHE, HTTP_CODE, LATENCY, } from '@office-start/telemetry-types';
import { logDiagnostic } from './logDiagnostic';
import { logRequest } from './logRequest';
var sampledRequestList = [
    "Check_Login" /* KnownRequestInstrumentationEvents.CheckLoginRequest */,
];
/*
 * This function is used in XHR service:
 *   * custom properties will be logged in Office.Taos.Hub.Diagnostic.Cache in Office.Taos.Hub.Diagnostic tenant
 *   * standard properties will be logged in Office.Taos.Hub.Request in Office.Taos.Hub tenant
 */
export function logRequestWithParams(params, securityThreshold) {
    if (securityThreshold === void 0) { securityThreshold = DataSecurityLevel.Security; }
    logRequest({
        eventName: params.eventName,
        error: params.error,
        latency: params.latency,
        fromCache: params.fromCache,
        httpCode: params.httpCode,
        area: params.area,
        subArea: params.subArea,
        id: params.instrumentationParams &&
            params.instrumentationParams["RequestId" /* KnownAriaInstrumentationParam.RequestId */]
            ? params.instrumentationParams["RequestId" /* KnownAriaInstrumentationParam.RequestId */]
            : '',
    }, securityThreshold, inSampledList(params.eventName));
    // log both standard custom fields to OTEL Diagnostic events
    if (
    // Don't log successful request to debug cache
    (params.httpCode < 200 || params.httpCode >= 300) &&
        params.instrumentationParams &&
        Object.keys(params.instrumentationParams).length > 0) {
        // Duplicate the standard properties to Diagnostic event to save effort joining table
        params.instrumentationParams[HTTP_CODE] = params.httpCode;
        if (params.error) {
            params.instrumentationParams[ERROR] = params.error;
        }
        if (params.fromCache) {
            params.instrumentationParams[FROM_CACHE] = params.fromCache;
        }
        if (params.latency) {
            params.instrumentationParams[LATENCY] = params.latency;
        }
        logDiagnostic({
            eventName: params.eventName,
            params: params.instrumentationParams,
            area: params.area,
            subArea: params.subArea,
        }, securityThreshold);
    }
}
export function inSampledList(eventName) {
    return sampledRequestList.includes(eventName);
}
//# sourceMappingURL=logRequestWithParams.js.map